import { Table } from '@/components/tax_rate/table'

export const TaxRates = () => {
  return (
    <>
      <Table createable onIndex />
    </>
  )
}
